/**
 * External dependencies
 */
import styled from '@emotion/styled';

/**
 * WordPress dependencies
 */
import { Icon } from '@wordpress/icons';

export const StyledIcon = styled( Icon )`
	width: 1em;
	height: 1em;
	margin: 0;
	vertical-align: middle;
	fill: currentColor;
`;
